import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import CompilerLanding from "../components/CompilerLanding";
import Header from "../components/Header";
import Dashboard from "../views/PreLogin/Dashboard";
import LandingPage from "../views/PreLogin/LandingPage";
import CommunityLoginRoutes from "./communityLoginRoutes";

const AppRoutes = () => {
  return (
    <>
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="*" element={<LandingPage />} />
          <Route path="/compiler" element={<CompilerLanding />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/community" element={<CommunityLoginRoutes />} />
        </Routes>
      </BrowserRouter>
    </>
  );
};

export default AppRoutes;
